import { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import UnderConstruction from './UnderConstruction';
import browserHistory from '../../history';

const pageStyle = {
    minHeight: 'calc(100vh - 180px)',
    backgroundColor: '#15171b',
    color: '#ffffff',
    padding: '60px 20px',
};

const containerStyle = {
    maxWidth: '760px',
    margin: '0 auto',
};

const headingStyle = {
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '12px',
};

const subheadingStyle = {
    fontSize: '18px',
    color: 'var(--highlight, #e9c548)',
    fontWeight: '600',
    marginBottom: '24px',
};

const bodyStyle = {
    fontSize: '15px',
    color: '#cccccc',
    lineHeight: '1.8',
    marginBottom: '20px',
};

const dividerStyle = {
    border: 'none',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    margin: '36px 0',
};

const cardRowStyle = {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: '20px',
};

const cardStyle = {
    flex: '1',
    minWidth: '180px',
    backgroundColor: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '8px',
    padding: '20px',
};

const cardTitleStyle = {
    fontSize: '14px',
    fontWeight: '700',
    color: 'var(--highlight, #e9c548)',
    marginBottom: '8px',
};

const emailBlockStyle = {
    backgroundColor: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '8px',
    padding: '28px 32px',
    textAlign: 'center',
};

const emailLabelStyle = {
    fontSize: '13px',
    color: '#aaaaaa',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '10px',
};

const emailLinkStyle = {
    fontSize: '22px',
    fontWeight: '700',
    color: 'var(--highlight, #e9c548)',
    textDecoration: 'none',
    fontFamily: `var(--bodyfont) !important`
};

class Partners extends Component {
    render() {
        const appName = window.app && window.app.appName;
        if (appName !== 'screenixx') {
            return <UnderConstruction {...this.props} />;
        }

        return (
            <div className="info-page">
                <Header />
                <div style={pageStyle}>
                    <div style={containerStyle}>
                        <h1 style={headingStyle}>Partner With Us</h1>
                        <p style={subheadingStyle}>Grow together with a platform built for storytellers.</p>

                        <p style={bodyStyle}>
                            Screenixx is actively seeking strategic partnerships with distributors, production companies, film festivals, technology providers, and content aggregators who share our commitment to quality storytelling and diverse voices.
                        </p>
                        {/* <p style={bodyStyle}>
                            Whether you want to license content, co-produce, integrate your service, or cross-promote to our audience — we're open to exploring opportunities that create value for both sides.
                        </p> */}

                        {/* <hr style={dividerStyle} />

                        <h2 style={{ ...headingStyle, fontSize: '22px', marginBottom: '20px' }}>Partnership Opportunities</h2>
                        <div style={cardRowStyle}>
                            <div style={cardStyle}>
                                <p style={cardTitleStyle}>Content Distribution</p>
                                <p style={{ ...bodyStyle, marginBottom: 0, fontSize: '13px' }}>License your catalog or titles for distribution on Screenixx.</p>
                            </div>
                            <div style={cardStyle}>
                                <p style={cardTitleStyle}>Technology Integration</p>
                                <p style={{ ...bodyStyle, marginBottom: 0, fontSize: '13px' }}>Integrate your tools, data, or services into our platform.</p>
                            </div>
                            <div style={cardStyle}>
                                <p style={cardTitleStyle}>Festival & Events</p>
                                <p style={{ ...bodyStyle, marginBottom: 0, fontSize: '13px' }}>Collaborate on film festivals, premieres, and live screenings.</p>
                            </div>
                        </div> */}

                        {/* <hr style={dividerStyle} /> */}

                        <div style={emailBlockStyle}>
                            <p style={emailLabelStyle}>Reach out to explore a partnership</p>
                            <a href="mailto:partners@screenixx.com" style={emailLinkStyle}>
                                partners@screenixx.com
                            </a>
                        </div>

                        <hr style={dividerStyle} />

                        <div style={{ ...emailBlockStyle, textAlign: 'center' }}>
                            <p style={{ ...emailLabelStyle, marginBottom: '16px' }}>Ready to join as a creator?</p>
                            <p style={{ ...bodyStyle, marginBottom: '24px' }}>
                                Apply as a creator on Screenixx and start sharing your work with a global audience.
                            </p>
                            <button
                                onClick={() => browserHistory.push('/creator')}
                                style={{
                                    padding: '12px 32px',
                                    background: 'var(--highlight, #e9c548)',
                                    border: 'none',
                                    borderRadius: '4px',
                                    color: '#15171b',
                                    fontWeight: '700',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                Become a Creator
                            </button>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Partners;
